import { useEffect, useState } from "react";

import * as frontLoaderActions from "shared/actions/frontLoaderActions";
import { GateProps } from "shared/components/GateProps";
import { useHasLoaded } from "shared/hooks/requestStatusHooks";

import { useAppDispatch } from "app/hooks";

const FrontLoadGate = ({ children, LoadingEl, ErrorEl }: GateProps) => {
  const labsLoaded = useHasLoaded(frontLoaderActions.frontLoadLabs);
  const labStationsLoaded = useHasLoaded(
    frontLoaderActions.frontLoadLabStations
  );
  const clinicsLoaded = useHasLoaded(frontLoaderActions.frontLoadClinics);
  const usersLoaded = useHasLoaded(frontLoaderActions.frontLoadUsers);

  const dispatch = useAppDispatch();
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    Promise.all([
      dispatch(frontLoaderActions.frontLoadLabs({})),
      dispatch(frontLoaderActions.frontLoadLabStations({})),
      dispatch(frontLoaderActions.frontLoadClinics({})),
      dispatch(frontLoaderActions.frontLoadUsers({})),
    ]).catch(() => setHasError(true));
  }, []);

  if (hasError)
    return (
      <ErrorEl className="FrontLoadGate">
        Failed to load Labs &amp; Clinics
      </ErrorEl>
    );

  if (!(labsLoaded && labStationsLoaded && clinicsLoaded && usersLoaded)) {
    return (
      <LoadingEl className="FrontLoadGate">
        Loading Labs &amp; Clinics...
      </LoadingEl>
    );
  }

  return <>{children}</>;
};

export default FrontLoadGate;
